import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColaboradorEncuestaervice {

  infoUsuario: any;
  idUsuario: string;
  idInstituto: string;
  idEmpresa: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.infoUsuario = this.authService.getInfoUsuario();
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    this.idEmpresa = this.infoUsuario.empresaId;
  }

  getinfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    return infoUsu;
  }
  getInfoUsuario(){
    return this.infoUsuario;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getInfoCentros(fecha:number){
    this.obtienInfo();
    
    //return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + this.idEmpresa, datos);
    if(localStorage.getItem('levelUser_tmp') == '1'){
      let datos = {fechaNorma35:fecha};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + this.idEmpresa, datos);
    }else{
      let datos = {fechaNorma35:fecha};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + localStorage.getItem('idPadre_temporal'), datos);
    }
  }

  getColaboradores_encuesta(idProducto:any){
    if(localStorage.getItem('levelUser_tmp') == '1'){
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.colaboradoresEncuesta + this.idEmpresa+'/'+idProducto+'/'+'$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO');
    }else{
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.colaboradoresEncuesta + localStorage.getItem('idPadre_temporal')+'/'+localStorage.getItem('producto_padreTmp')+'/'+'$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO');
    }
  }


  getColaboradores_url(idProducto:any){
    
    if(localStorage.getItem('levelUser_tmp') == '1'){
      let datos = {productoId:idProducto};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getUrlColaboradores + this.idEmpresa, datos);
    }else{
      console.log("Service");
      let datoshijo = {productoId:localStorage.getItem('producto_padreTmp')};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getUrlColaboradores +localStorage.getItem('idPadre_temporal'), datoshijo);
    }
  }

  sendColaboradores_url(idProducto:any, idCT:any, idExcel:any){
    
    if(localStorage.getItem('levelUser_tmp') == '1'){
      let url='http://localhost:4200/home?empresa='+this.idEmpresa+'&pod='+idProducto+'&centro='+idCT+'&idct='+idExcel;
      let datos = {
        productoId:idProducto,
        centroId: idCT,
        urlLarga: url
      };
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.urlColaboradores + this.idEmpresa, datos);
    }else{
      let url='http://localhost:4200/home?empresa='+localStorage.getItem('idPadre_temporal')+'&pod='+localStorage.getItem('producto_padreTmp')+'&centro='+idCT+'&idct='+idExcel;
      let datos = {
        productoId:localStorage.getItem('producto_padreTmp'),
        centroId: idCT,
        urlLarga: url
      };
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.urlColaboradores + localStorage.getItem('idPadre_temporal'), datos);
    }
  }
}
